import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import useStore from '../../../store';
import { BookingWithDocumentsStatus } from '../../../types/documents';
import MultiCheckbox from '../../UI/MultiCheckbox';
import {
  StyledFieldset,
  StyledForm,
  StyledLegend,
  StyledMultiCheckboxWrapper,
} from './DocumentListFilter.styles';

export interface DocumentListFilterProps {
  activeOptions: Array<BookingWithDocumentsStatus>;
  onActiveOptionsChange: (
    newActiveOptions: Array<BookingWithDocumentsStatus>,
  ) => void;
}

export function DocumentListFilter({
  activeOptions,
  onActiveOptionsChange,
}: DocumentListFilterProps): JSX.Element {
  const { t } = useTranslation(['booking']);
  const user = useStore(state => state.user);

  function onChange(newOptions: string[]) {
    onActiveOptionsChange(newOptions as Array<BookingWithDocumentsStatus>);
  }

  return (
    <StyledForm>
      <StyledFieldset>
        <StyledLegend>
          {upperFirst(t('booking:filterByBookingStatus'))}
        </StyledLegend>
        <StyledMultiCheckboxWrapper>
          <MultiCheckbox
            activeOptions={activeOptions}
            options={[
              {
                name: BookingWithDocumentsStatus.Active,
                label: upperFirst(t('booking:active')),
              },
              {
                name: BookingWithDocumentsStatus.Inactive,
                label: upperFirst(t('booking:inactive')),
              },
            ]}
            user={user?.type}
            onChange={onChange}
          />
        </StyledMultiCheckboxWrapper>
      </StyledFieldset>
    </StyledForm>
  );
}
